import { render, staticRenderFns } from "./ProjectAboutT.vue?vue&type=template&id=49e4f2a0&scoped=true&"
import script from "./ProjectAboutT.vue?vue&type=script&lang=ts&"
export * from "./ProjectAboutT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAboutT.vue?vue&type=style&index=0&id=49e4f2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4f2a0",
  null
  
)

export default component.exports